import { createContext, type Dispatch, type SetStateAction } from "react";

type TimeSpanInputContext = [Date | null, Dispatch<SetStateAction<Date | null>>];
export const TimeSpanInputContext = createContext<TimeSpanInputContext>(null!);
